import {
    PURCHASES_CLEAR_CART,
    PURCHASES_TOGGLE_OFFER,
    PurchasesAction
} from 'actions/purchases/PurchasesActionsTypes';
import { PurchasesState } from 'reducers/purchases/PurchasesState';

const initialState: PurchasesState = {
    cart: {}
};

export const purchasesReducer = (
    state: PurchasesState = initialState,
    action: PurchasesAction
): PurchasesState => {
    switch (action.type) {
        case PURCHASES_TOGGLE_OFFER: {
            const { petUuid, offerId } = action.payload;
            const petOffers = state.cart[petUuid] ?? [];

            return {
                ...state,
                cart: {
                    ...state.cart,
                    [petUuid]: petOffers.includes(offerId)
                        ? petOffers.filter(id => id !== offerId)
                        : [...petOffers, offerId]
                }
            };
        }
        case PURCHASES_CLEAR_CART:
            return initialState;
        default:
            return state;
    }
};
